import { Col, Row } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { IoIosArrowBack } from 'react-icons/io';

import { DocumentModel } from 'api/documents/documents.model';
import { BasicCard } from 'components/BasicCard';
import Button from 'components/Buttons';
import Detail from 'components/Detail';
import Title from 'components/Title';
import useCertificateHelper from 'hooks/useCertificateHelper';
import useDocumentDetails from 'hooks/useDocumentDetails';
import { ADDITIONAL_DETAILS, CertificateDetailsModel } from 'models/certificate.model';

type TemplateProps = {
  document: DocumentModel<CertificateDetailsModel>;
  rigthCard: ReactNode;
  children?: ReactNode;
};

const Template = ({
  document: { additionalDetails = {} as CertificateDetailsModel, ...document },
  rigthCard,
  children,
}: TemplateProps) => {
  const { t } = useTranslation();
  const { onBack } = useDocumentDetails();
  const { getLabel } = useCertificateHelper();

  return (
    <>
      <Row justify="space-between">
        <Button type="text" $uppercase icon={<IoIosArrowBack />} onClick={onBack}>
          {t('nav.back')}
        </Button>
      </Row>
      <Title padding="1rem 0">{t(`certificate.${document.category}`)}</Title>

      <Row gutter={[16, 16]}>
        <Col md={24} lg={10}>
          <BasicCard $height="100%">
            <Detail
              label={getLabel(ADDITIONAL_DETAILS.RECIPIENT)}
              value={additionalDetails[ADDITIONAL_DETAILS.RECIPIENT]}
            />
            <Detail
              label={getLabel(ADDITIONAL_DETAILS.ISSUER)}
              value={additionalDetails[ADDITIONAL_DETAILS.ISSUER]}
            />
            <Detail label={getLabel('passportId')} value={document.documentBlockchainAddress} />
          </BasicCard>
        </Col>
        <Col md={24} lg={14}>
          <BasicCard $height="100%">{rigthCard}</BasicCard>
        </Col>
      </Row>

      {children}
    </>
  );
};

export default Template;
